import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { clearBatch } from "state/reducers/smsBatching";
import { useHistory } from "react-router";
import MarketingNavigation from "../utils/components/MarketingNavigation";
import SMSMarketingStepper from "../utils/components/sms/SMSMarketingStepper";
import MarketingButtons from "../utils/components/MarketingButtons";
import MarketingToolTip from "../utils/components/MarketingToolTip";
import SMSChatBubble from "../utils/components/sms/SMSChatBubble";
import MarketingContainer from "../utils/components/MarketingContainer";
import "../utils/styles/marketing-dashboard.css";

const SMSBatchEditor = () => {
  const [error, setError] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const handleDiscardChanges = () => {
    dispatch(clearBatch());
    history.push("/marketing");
  };
  const message = useSelector((state) => state.smsBatching.message);
  const batchName = useSelector((state) => state.smsBatching.batchName);
  return (
    <MarketingContainer>
      <MarketingNavigation>
        <MarketingToolTip>
          <small className="">
            <i className="fas fa-info-circle text-gray-600 pr-2" />
            Try adding emojis
            <i className="fas fa-smile mx-1" />
            or variables
            <i className="fas fa-brackets-curly mx-1" />
          </small>
        </MarketingToolTip>
      </MarketingNavigation>
      <SMSMarketingStepper />
      <div className="flex flex-col justify-center mx-auto my-auto bg-transparent rounded-lg">
        <SMSChatBubble enabled setError={setError} error={error} />
      </div>
      <MarketingButtons
        prevButton="Discard"
        prevLink="/marketing"
        nextButton="Continue"
        nextLink="/marketing/sms/upload"
        required={
          !(
            !error &&
            message &&
            batchName &&
            message.length &&
            batchName.length &&
            message.length < 161 &&
            message.trim().length &&
            batchName.trim().length
          )
        }
        discardChanges={handleDiscardChanges}
      />
    </MarketingContainer>
  );
};

export default SMSBatchEditor;
